import styled from 'styled-components';
import theme from "./../../styles/theme"

export const Postsbox = styled.div`
  padding: 20px;
`;

export const DescriptionWrapper = styled.div`

`;

export const Title = styled.h2`
  font-family: ${theme.fonts.montSerrat};
  font-style: normal;
  font-weight: 600 !important;
  font-size: 15px;
  line-height: 23px;
  color: ${theme.colors.gray};
  text-align: initial;
  padding: 20px 0px;
`;

export const BoxTitle = styled.div`

`;

export const Description = styled.p`
  font-family: ${theme.fonts.montSerrat};
  font-style: normal;
  font-weight: 500;
  font-size: ${theme.fontSizes.small};
  line-height: 22px;
  color: ${theme.colors.gray};
  text-align: initial;
  padding: 20px 0px 0;
`;

export const DescriptionBox = styled.div`

`;
